import { Location } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ActivosService } from '../activos/activos.service';
import { NotificacionesService } from '../../../core/notificaciones/notificaciones.service';

@Component({
    selector: 'fuse-xd-viewer',
    templateUrl: './xd-viewer.component.html',
    styleUrls: ['./xd-viewer.component.scss']
})
export class XdViewerComponent implements OnInit, OnDestroy {

    url: string;
    type: string;

    navigationSubscription;

    idActivo: number;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private location: Location,
        private activosService: ActivosService,
        private notificaciones: NotificacionesService
    ) {
        this.url = this.route.snapshot.paramMap.get('enlace');
        this.type = this.route.snapshot.paramMap.get('type');
        this.idActivo = Number(this.route.snapshot.paramMap.get('id'));

        // notify about the new activo
        this.activosService.setCurrentActivo(this.idActivo)

        this.navigationSubscription = this.router.events.subscribe((e: any) => {
            // If it is a NavigationEnd event re-initalise the component
            if (e instanceof NavigationEnd) {
                this.initialiseInvites();
            }
        });

        location.go('/3d-viewer');

    }

    ngOnInit() { }

    initialiseInvites() {
        // Set default values and re-fetch any data you need.
        this.url = this.route.snapshot.paramMap.get('enlace');

    }
    ngOnDestroy() {
        // avoid memory leaks here by cleaning up after ourselves. If we
        // don't then we will continue to run our initialiseInvites()
        // method on every navigationEnd event.
        if (this.navigationSubscription) {
            this.navigationSubscription.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/xd-viewer/xd-viewer.component.ts